import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist';

import appReducer from 'redux/app/appSlice'
import authReducer from 'redux/auth/authSlice'
import userReducer from 'redux/user/userSlice'
import vpsReducer from 'redux/vps/vpsSlice'
import monitoringReducer from 'redux/monitoring/monitoringSlice'
import partnersReducer from 'redux/partners/partnersSlice'
import balanceReducer from 'redux/balance/balanceSlice'
import paymentReducer from 'redux/payment/paymentSlice'
import supportReducer from 'redux/support/supportSlice'
import profileReducer from 'redux/profile/profileSlice'
import faqReducer from 'redux/faq/faqSlice'

const storage =
  typeof window !== 'undefined'
    ? {
      getItem: (key) => Promise.resolve(localStorage.getItem(key)),
      setItem: (key, value) => {
        localStorage.setItem(key, value);
        return Promise.resolve(value);
      },
      removeItem: (key) => {
        localStorage.removeItem(key);
        return Promise.resolve();
      },
    }
    : {
      getItem: () => Promise.resolve(null),
      setItem: (_key, value) => Promise.resolve(value),
      removeItem: () => Promise.resolve(),
    };

const authPersistConfig = {
  key: 'auth',
  storage,
}

const rootReducer = combineReducers({
  app: appReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  user: userReducer,
  vps: vpsReducer,
  monitoring: monitoringReducer,
  partners: partnersReducer,
  balance: balanceReducer,
  payment: paymentReducer,
  support: supportReducer,
  profile: profileReducer,
  faq: faqReducer,
})

const customizedMiddleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST'],
    }
  })

export const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
  devTools: import.meta.env.VITE_NODE_ENV === 'development',
})

export const persistor = persistStore(store);

export default { store, persistor };
